// config
import * as http from 'utils/http';
import config from 'config';

const createNewTicket = async ({ ticketDto }) => {
  return http.post(`${config.API_URL}price-negotiation/tickets/`, ticketDto);
};

export default createNewTicket;
